export default "__VITE_ASSET__GCDKUAK0__"